var _path, _rect, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg100StackedColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M11 10C11 9.44772 11.4477 9 12 9H18C18.5523 9 19 9.44772 19 10V41H11V10Z",
    fill: "#AFB8C1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bright-fill",
    width: 8,
    height: 12,
    transform: "translate(11 29)",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M23 10C23 9.44772 23.4477 9 24 9H30C30.5523 9 31 9.44772 31 10V41H23V10Z",
    fill: "#AFB8C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "bright-fill",
    width: 8,
    height: 20,
    transform: "translate(23 21)",
    fill: "#D0D7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    d: "M1 1V41H41",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100StackedColumn);
export default __webpack_public_path__ + "static/media/100%-stacked-column.35da8006f7999a70a6be226707964ca2.svg";
export { ForwardRef as ReactComponent };